import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toJS } from '../../../utils/immutableUtils';
import { getPpiById, getIsFetching } from '../selectors';
import { fetchPpi } from '../actions';

const usePpi = ppiId => {
  const [notStartedFetching, setNotStartedFetching] = useState(true);
  const dispatch = useDispatch();
  const ppi = useSelector(getPpiById(ppiId));
  const isFetchingPpi = useSelector(getIsFetching);
  const isFetching = notStartedFetching ? true : isFetchingPpi;

  useEffect(() => {
    dispatch(fetchPpi(ppiId));
    setNotStartedFetching(false);
  }, [dispatch, ppiId]);

  return [isFetching ? null : toJS(ppi), isFetching];
};

export default usePpi;
